var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"floating-container",on:{"click":function($event){return _vm.$emit(`click`)}}},[_c('div',{staticClass:"floating-button"},[_c('font-awesome-icon',{attrs:{"icon":"fa-solid fa-add"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }